<template>
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8481 1.35895C16.0463 1.16672 16.0512 0.85017 15.859 0.651927C15.6667 0.453685 15.3502 0.448815 15.1519 0.64105L5.1875 10.3035L0.848073 6.0956C0.649831 5.90336 0.333285 5.90823 0.14105 6.10647C-0.0511852 6.30472 -0.0463153 6.62126 0.151927 6.8135L4.83943 11.359C5.03337 11.547 5.34163 11.547 5.53557 11.359L15.8481 1.35895Z"
      fill="white"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconCheck extends Vue {}
</script>
